import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pdt-30" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center pdb-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "Form Submissions", -1)
const _hoisted_4 = { class: "filters d-flex gap-4 flex-wrap flex-md-nowrap justify-content-between w-100" }
const _hoisted_5 = { class: "d-flex gap-4 col-md-8 col-12 w-sm-100" }
const _hoisted_6 = { class: "small striped toggle no-underline" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", { class: "large" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "7" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "pdl-10 pdr-10 d-flex justify-content-between w-100" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Participant "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, " Web Submission Date "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, " Form Type "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, " Person Name "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Person D.O.B. "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 pdl-20" }, " Notes "),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, " Status ")
      ])
    ])
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "7" }
const _hoisted_10 = { class: "d-flex flex-column w-100" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap w-100 sm-gap-20" }
const _hoisted_12 = { class: "cell col-md-1 col-sm-5" }
const _hoisted_13 = { class: "cell col-md-2 col-sm-5" }
const _hoisted_14 = { class: "cell col-md-2 col-sm-5 text-wrap" }
const _hoisted_15 = { class: "cell col-md-2 col-sm-5" }
const _hoisted_16 = { class: "cell col-md-1 col-sm-5" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "plan-modal iatse-icon-minus"
}
const _hoisted_20 = {
  key: 1,
  class: "plan-modal iatse-icon-table-plus"
}
const _hoisted_21 = { class: "cell col-md-1 col-sm-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "bullet" }, null, -1)
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = {
  key: 0,
  class: "text-center pdt-20 pdb-10"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", { class: "text-center py-5" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, " No submissions found ")
], -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleExport && $setup.handleExport(...args)))
      }, _toDisplayString($setup.loadingExport ? 'Exporting...' : 'Export To CSV'), 1)
    ]),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "bordered-card bordered-card_secondary",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SelectComponent, {
                selectedOption: $setup.filters.FormType,
                "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.FormType) = $event)),
                options: $setup.formTypes,
                "single-arrow": true,
                customClass: "fs-xs"
              }, null, 8, ["selectedOption", "options"]),
              _createVNode(_component_SelectComponent, {
                selectedOption: $setup.filters.Status,
                "onUpdate:selectedOption": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.Status) = $event)),
                options: $setup.statuses,
                "single-arrow": true,
                customClass: "fs-xs"
              }, null, 8, ["selectedOption", "options"])
            ]),
            _createVNode(_component_TextInput, {
              type: "text",
              name: "mixed",
              placeholder: "Search by ID or Name...",
              max: 30,
              modelValue: $setup.filters.Participant,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.Participant) = $event)),
              customClass: "search justify-content-start"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            ($setup.submissions.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.submissions, (submission) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: submission.SubmissionID,
                      class: _normalizeClass(['large', { 'closed': submission.Status === 'Closed' }])
                    }, [
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(submission.PersonID), 1),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(submission.WebSubmissionDate), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(submission.FormType), 1),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(submission.PersonName), 1),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(submission.PersonDateofBirth), 1),
                            _createElementVNode("div", {
                              onClick: ($event: any) => ($setup.toggleNotes(submission.SubmissionID)),
                              class: "cell col-md-3 col-sm-5 pdl-20 pdr-25 sm-pdr-0 sm-pdl-0 d-flex justify-content-between align-items-center"
                            }, [
                              _createElementVNode("span", {
                                innerHTML: $setup.getTruncatedNotes(submission?.Notes)
                              }, null, 8, _hoisted_18),
                              (submission?.Notes.length > 30)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    ($setup.isExpanded(submission.SubmissionID))
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                                      : _createCommentVNode("", true),
                                    (!$setup.isExpanded(submission.SubmissionID))
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_17),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("small", {
                                class: _normalizeClass(["label label_small w-fit", { 'label_danger_secondary': submission.Status == 'Open', 'label_blue': submission.Status == 'Closed' }])
                              }, [
                                _hoisted_22,
                                _createTextVNode(" " + _toDisplayString(submission.Status), 1)
                              ], 2),
                              (submission.Status === 'Open')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    disabled: submission.Submitting,
                                    onClick: _withModifiers(($event: any) => ($setup.handleCloseSubmission(submission.SubmissionID)), ["prevent"]),
                                    class: "btn btn-primary btn-x-small mt-10"
                                  }, " Close ", 8, _hoisted_23))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode(_Transition, { name: "slide-fade" }, {
                            default: _withCtx(() => [
                              ($setup.isExpanded(submission.SubmissionID) && submission?.Notes.length > 30)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createElementVNode("p", {
                                      innerHTML: $setup.formatNotes(submission?.Notes)
                                    }, null, 8, _hoisted_25)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ], 2))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_26, _hoisted_28))
          ]),
          _createVNode(_component_PaginationComponent, {
            paginator: $setup.paginator,
            onFetchData: $setup.fetchPaginationData
          }, null, 8, ["paginator", "onFetchData"])
        ], 32))
  ]))
}